import { JoonUIColor, Loader, SPACING, Typography } from "@joonapp/web-shared"
import { useState } from "react"
import { useNavigate } from "react-router-dom"

import { signInWithGoogle } from "../../networking/authentication/api"

interface Props {
  setFormAlert?: (alert: any) => void
}

function GoogleAuth({ setFormAlert = () => {} }: Props) {
  const [isHovered, setIsHovered] = useState<boolean>(false)
  const [pending, setPending] = useState<boolean>(false)
  const navigate = useNavigate()

  const onSigninWithGoogle = async () => {
    setPending(true)
    try {
      await signInWithGoogle()
      navigate("/")
    } catch (err) {
      // this is assuming that the error is because the user does not exist
      setFormAlert({
        type: "error",
        message: "User does not exist. Please sign up.",
      })
    } finally {
      setPending(false)
    }
  }

  return (
    <button
      type="submit"
      disabled={pending}
      onClick={onSigninWithGoogle}
      style={{
        borderRadius: SPACING.space2,
        width: "100%",
        display: "flex",
        alignItems: "center",
        border: `1px solid #ddd`,
        position: "relative",
        textAlign: "center",
        justifyContent: "center",
        padding: `10px ${SPACING.space4}`,
        background: isHovered
          ? JoonUIColor.background.xlightGray
          : JoonUIColor.background.primaryNeutral,
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div
        style={{
          position: "absolute",
          alignItems: "center",
          display: "inline-flex",
          justifyContent: "center",
          width: "1.5em",
          height: "1.5em",
          left: SPACING.space4,
        }}
      >
        <img
          src={`https://uploads.divjoy.com/icon-google.svg`}
          alt={"Google"}
          style={{ display: "block", width: "100%" }}
        />
      </div>

      {pending ? (
        <Loader size={24} color={JoonUIColor.text.primary} thickness={2} />
      ) : (
        <Typography variant="body" color={JoonUIColor.text.secondary}>
          Sign in with Google
        </Typography>
      )}
    </button>
  )
}

export default GoogleAuth
